<template>
    <div id="app" class="outer">
        <header class="header">
            <div class="bottom">
                <h1 style="height:82px" class="logoArea" @click="$router.push('/')">
                    <!-- <img src="./assets/images/logo.png" height="82px" alt=""> -->
                    QIANYUANMAIL
                </h1>
                <div class="searchArea">
                    <form action="###" class="searchForm">
                        <input type="text" id="autocomplete" class="input-error input-xxlarge" />
                        <button class="sui-btn btn-xlarge btn-danger" type="button">搜索</button>
                    </form>
                    <span class="pr8">New Arrivals: </span> <span class="pr8 pointer hoverRed">earphone</span>
                </div>
                <div @click="$router.push('/shopping')" class="pointer hoverRed" style="position: relative;">
                    <i class="iconfont icon-gouwuche"></i>
                    <span>Cart</span>
                    <div v-if="cartListNum" class="num">{{ cartListNum }}</div>
                </div>
                <div @click="opneLogin" class="pointer hoverRed">
                    <i class="iconfont icon-yonghu"></i>
                    <span>My Account</span>
                </div>
            </div>
        </header>

        <router-view class="con"></router-view>

        <div class="footer">
            <div class="footer-container">
                <div class="footerList">
                    <div class="footerItem" style="width: 20%;">
                        <h4>Customer Help Center</h4>
                        <ul class="footerItemCon">
                            <!-- <li>Dispute resolution policy</li> -->
                            <li @click="$router.push('/foot/termsofUse')">Terms of Use</li>
                            <li @click="$router.push('/foot/privacyPolicy')">Privacy Policy</li>
                        </ul>
                    </div>
                    <div class="footerItem" style="width: 28%;">
                        <h4>Shopping Guide</h4>
                        <ul class="footerItemCon">
                            <li @click="$router.push('/foot/howDoPay')">How do I pay on QIANYUANMAIL?</li>
                            <!-- <li>How to apply aftersale/ Refund</li> -->
                        </ul>

                    </div>
                    
                    <div class="footerItem" style="width: 22%;">
                        <h4>Company</h4>
                        <ul class="footerItemCon">
                            <!-- <li >Company Info</li> -->
                            <li @click="$router.push('/foot/companyInfo')">Company Info</li>
                        </ul>
                    </div>
                    <div class="footerItem" style="width: 15%;">
                        <h4>International</h4>
                        <ul class="footerItemCon">
                            <li  @click="$router.push('/foot/contact')">Contact Us</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot-bottom">
            <!-- <img src="./assets/images/home/pingpai.png" alt=""> -->
        </div>
        <div class="copyright">THOUSANDS RESOURCES NETWORK TECHNOLOGY CO., LTD</div>
        <div class="copyright">FLAT/RM D07, 8/F, KAI TAK FTY BUILDING, NO.99 KING FUK STREET, SAN PO KONG, KL</div>
        <div class="copyright">Copyright 2026 THOUSANDS RESOURCES NETWORK TECHNOLOGY CO., LTD All rights reserved.</div>

        <logindialog ref="dialog"></logindialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
import './style/home.css';
import logindialog from './views/loginDialog/index.vue';
export default {
    name: 'App',
    components: { logindialog },
    computed: {
        ...mapState({
            cartListNum: state => state.user.cartListNum
        })
    },
    methods: {
        opneLogin() {
            this.$refs.dialog.show()
        }
    }
}
</script>

<style scoped>
.num {
    width: 14px;
    height: 14px;
    font-size: 12px;
    color: #ffffff;
    background: #d01e24;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 20px;
    text-align: center;
    line-height: 14px;
}
.footerItemCon li {
    cursor: pointer;
}
.con {
    min-height: calc(100vh - 110px - 330px);
}
</style>
